import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

type CardRowProps = {
  className?: string;
  children: React.ReactNode;
} & VariantProps<typeof cardRowStyles>;

const cardRowStyles = cva(twMerge('w-full'), {
  variants: {
    direction: {
      row: 'flex flex-row',
      column: 'flex flex-column',
    },
    justify: {
      default: '',
      between: 'justify-between items-center',
      start: 'justify-start items-center',
    },
  },
  defaultVariants: {
    direction: 'row',
    justify: 'between',
  },
});

export const CardRow = (props: CardRowProps) => {
  const { children, direction, justify, className } = props;
  const classNames = twMerge(cardRowStyles({ direction, justify }), className);
  return (
    <div className={classNames}>
      {React.Children.map(children, (child) => child)}
    </div>
  );
};
